<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs1-17",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 17,
      nextPage: '/questionnaire/section2',
      navigateType: 'CLICK_ANY_BTN',
      content: {
        componentsType: {
          pc: 'normalBtn',
          mobile: 'normalBtn'
        },
        titleIcon: require('@/assets/icon/questionIcon/Lactation.png'),
        mainTitle: 'Have you used our Lilac Kegal Exerciser?',
        btn: [
          [
            {
              text: 'Yes',
            },{
              text: 'No',
            }
          ]
        ]
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
